export default "__VITE_ASSET__3ef1249d__"